import { onMounted, onUnmounted, ref, type Ref } from "vue"

/**
 * Reactive boolean: `true` when the viewport is at or above the `lg` breakpoint
 * (1024px). Mirrors Tailwind's `lg:` breakpoint.
 */
export function useLgBreakpoint(): Ref<boolean> {
  const query = "(min-width: 1024px)"
  const isLg = ref(
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false
  )

  let mql: MediaQueryList | null = null
  const handler = (e: MediaQueryListEvent) => { isLg.value = e.matches }

  onMounted(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return
    mql = window.matchMedia(query)
    isLg.value = mql.matches
    mql.addEventListener("change", handler)
  })

  onUnmounted(() => {
    if (mql) {
      mql.removeEventListener("change", handler)
      mql = null
    }
  })

  return isLg
}
